import { useState } from "react";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import Modal from "@components/Modal/Modal";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import DownloadForm from "@routes/Keyword/templates/AseanInsights/components/DownloadForm/DownloadForm";
import { DownloadButtonAttributes } from "@routes/Keyword/templates/AseanInsights/utils/types";
import { cn } from "@util/helpers";

type DownloadReportProps = {
  /** The button attributes, contains text and classname. */
  attributes: DownloadButtonAttributes;
  /** The URL of the attachment do be viewed/downloaded. */
  attachmentURL: string;
};

/** The download button widget, which opens modal when clicked. */
const DownloadReport = ({
  attachmentURL,
  attributes: { className: buttonClassName, text, type, gaEvent },
}: DownloadReportProps): React.ReactElement => {
  const sendDataToGTM = useSendDataToGTM();
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    // Send GA Custom Event.
    sendDataToGTM(gaEvent);

    // Open modal
    setShowModal(true);
  };

  return (
    <>
      <ButtonFactory
        buttonType={ButtonType.Primary}
        text={text}
        className={buttonClassName}
        onClick={type === "hero" ? handleClick : undefined}
      />

      {type === "widget" ? (
        <div className="absolute inset-0" onClick={handleClick}></div>
      ) : null}

      <Modal
        isModalOpen={showModal}
        setIsModalOpen={setShowModal}
        dialogPanelClassNames={cn(
          "p-8 rounded-none h-full",
          "md:w-[40rem] md:max-h-[37.5rem] md:h-auto"
        )}
      >
        <ButtonFactory
          buttonType={ButtonType.Secondary}
          className="absolute right-3 top-3 border-none p-0"
          onClick={() => {
            setShowModal(false);
          }}
          icon={
            <IconFactory
              type={IconTypeEnum.close}
              size={32}
              className="text-gray-850"
            />
          }
        />

        <DownloadForm
          attachmentURL={attachmentURL}
          setShowModal={setShowModal}
        />
      </Modal>
    </>
  );
};

export default DownloadReport;
